<adf-login
  successRoute="/{{ successRoute }}"
  logoImageUrl="./assets/images/alfresco-logo.svg"
  backgroundImageUrl="./assets/images/Wallpaper-BG-generic.svg"
  [copyrightText]="'application.copyright' | adfAppConfig | translate"
  [showRememberMe]="false"
  [showLoginActions]="false"
>
  <div>
    <a [routerLink]="['/reset-password']">{{
      'APP.FORGOT_YOUR_PASSWORD' | translate
    }}</a>
  </div>
  <adf-login-footer *ngIf="ssoEnabled">
    <ng-template>
      <div class="sso-action" (click)="loginViaSso()" (keyup)="loginViaSso()">
        {{ 'APP.SSO_LOGIN' | translate }}
      </div>
    </ng-template>
  </adf-login-footer>
</adf-login>
<div *ngIf="isFailed">
  You are not allowed to log in or an error occurred during the authorization
  request. Please contact your administrator.
</div>
